import { AnySimple, EventType, Type } from 'nanium/objects';
import { EventBase } from '../../eventBase';

@EventType({
  scope: 'private'
})
export class ApplicationFieldChangeEvent<T = any> extends EventBase<ApplicationFieldChangeEvent<T>> {
  static eventName: string = 'EduApplicationClient:application/field/change';

  @Type(String) fieldName: string;
  @Type(AnySimple) oldValue: T;
  @Type(AnySimple) newValue: T;
  @Type(AnySimple) storedValue: T;
}
